"use client";

import { createContext, useContext, useMemo } from "react";

import { useOpenWithFocus } from "./use-open-with-focus";

type CallbackContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const CallbackContext = createContext<CallbackContextValue | null>(null);

export function CallbackProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useOpenWithFocus(false);
  const value = useMemo(() => ({ open, setOpen }), [open, setOpen]);
  return <CallbackContext.Provider value={value}>{children}</CallbackContext.Provider>;
}

export function useCallbackPanel() {
  const ctx = useContext(CallbackContext);
  if (!ctx) {
    throw new Error("useCallbackPanel must be used inside CallbackProvider");
  }
  return ctx;
}
